import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "./login.css";
import { GoogleLogin } from "@react-oauth/google";

import authService from "../../../services/authServices";
import { END_POINTS } from "../../../services/endpoint/endPoint";
import { useNavigate, Link } from "react-router-dom";

const Login = ({ setLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const emailChangeHandler = (e) => {
    setUsername(e.target.value.toLowerCase());
  };

  const passwordChangeHandler = (e) => {
    setPassword(e.target.value);
  };

  const login = (e) => {
    e.preventDefault();
    const data = { email: username, password };

    authService
      .login(END_POINTS.login, data)
      .then((res) => {
        handleSuccess(res);
      })
      .catch((error) => {
        if (error.response) {
          toast.error(error.response.data.error, {
            position: "top-right",
          });
        }
      });
  };

  const handleSuccess = (res) => {

    const data = res.data.data;
    localStorage.setItem("accessToken", data.token);
    localStorage.setItem("role", data.role);
    localStorage.setItem("user", JSON.stringify(data));
    localStorage.setItem("user_logo", data.user_logo);
    localStorage.setItem("user_id", data.id);
    localStorage.setItem("prefers_personal_ui", data.prefers_personal_ui);

    if (data.brand_access)
      localStorage.setItem("brand_access", data.brand_access);
    else localStorage.removeItem("brand_access");
    setLogin(true);
    navigate("/");
  };

  const handleGoogleLogin = (credentialResponse) => {
    const token = credentialResponse.credential;

    const payload = {
      googleToken: token,
    };

    authService
      .login(END_POINTS.login, payload)
      .then((res) => {
        handleSuccess(res);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Google login failed", {
          position: "top-right",
        });
      });
  };

  return (
    <>
      <ToastContainer />
      <div className="login_wraper">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <figure>
                <img src="../../../assets/images/logo.svg" alt="logo" />
              </figure>
              <p>Log in to view personalized recommendations and more.</p>
            </div>
            <div className="col-md-6">
              <h1>Welcome To Tecreo!</h1>
              <form onSubmit={login}>
                <div className="form-group">
                  <label>User Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter your email"
                    onChange={emailChangeHandler}
                  />
                </div>
                <div className="form-group">
                  <label>Enter Your Password</label>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Enter your password"
                    onChange={passwordChangeHandler}
                  />
                </div>
                <div>
                  <button type="submit" className="btn">
                    Sign In
                  </button>
                </div>
                <div>
                  <Link to="/forget-password" className="forgot-password-link">
                    Forgot Password?
                  </Link>
                </div>
              </form>
              <br />
              <div
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "12px",
                  padding: "20px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  textAlign: "left",
                  // maxWidth: "300px",
                  margin: "0 auto",
                  backgroundColor: "#fff",
                }}
              >
                <p style={{ marginBottom: "15px", fontWeight: "bold", color:"rgb(0, 73, 170)" }}>
                  Or sign in with Google
                </p>
                <div className="google-login-wrapper">
                  <GoogleLogin
                    onSuccess={handleGoogleLogin}
                    onError={() => {
                      toast.error("Google login failed");
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="audience-segments-wrapper">
              <Link to="/audience-segments" className="audience-segments-link">
                Audience Segments
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
